module.exports = __webpack_public_path__ + "public/images/generated-explore-dance.2e035a804d81933ed2a23868f03cc95a.jpg";